import { Directive, TemplateRef } from '@angular/core';

@Directive({ standalone: false, selector: '[appQueryButtonGroup]' })
export class QueryButtonGroupDirective
{
  constructor(public template: TemplateRef<any>) { }
}
